import { CryptocurrenciesEnum, CurrencyEnum } from '../../../../lib/enums';
import lang from '../../../../lib/language';
import { Payment } from '../../../../lib/models/crm/types';
import { renderWalletName } from '../../../../lib/util/CryptoHelpers';

import styles from './BasicModal.module.scss';

type SolanaPayment = {
  category: string;
  paymentReference: string;
  payment: Payment;
}

type Props = {
  infoModal: SolanaPayment
}

const SolanaModal = ({ infoModal }: Props) => {
  const {
    category,
    payment,
  } = infoModal;

  const {
    payment_reference,
    crypto_detail_rate,
    recipient_crypto_wallet_address,
  } = payment;

  const cryptoContent = [
    {
      [lang.mobileTransactionTypeLabelCategory()]: category,
      [lang.mobileTransactionTypeLabeLCryptoRate(CurrencyEnum.USD, CryptocurrenciesEnum.USDT)]: `1:${crypto_detail_rate}`,
    },
  ];
  const cryptoDetails = [
    {
      [lang.mobileTransactionTypeLabelCrypto()]: renderWalletName(recipient_crypto_wallet_address),
      [lang.mobileTransactionTypeLabelPaymentRef()]: payment_reference,
    },
  ];

  const renderDetails = (item, index: number) => (
    <div className={styles.card} key={index as number}>
      {
        Object.entries(item)
          .map(([key, value]) => {
            if (!value) {
              return null;
            }
            return (
              <div className={styles.cardContent} key={key}>
                <span className={styles.cardKey}>{key}</span>
                <span className={styles.cardValue}>{value as string}</span>
              </div>
            );
          })
       }
    </div>
  );

  return (
    <>
      <div className={styles.wrapperCategoryDetails}>
        <div className={styles.containerDetails}>
          { cryptoContent.map((item, index) => renderDetails(item, index))}
        </div>
      </div>
      <div>
        <p className={styles.whiteText}>
          {lang.mobileTransactionTypeToCryptoAccountHeading()}
        </p>
        <div className={styles.wrapperCategoryDetails}>
          <div className={styles.containerDetails}>
            {cryptoDetails.map((item, index) => renderDetails(item, index))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SolanaModal;
